import React from 'react';
import { Label, Input, FormGroup, Col } from 'reactstrap';
import i18n from '../../../../../i18next';

const AvailabilityCustomSelection = props => {

    const { container, activeElement, containerItem } = styles;

    return (
        <Col sm={12} style={container}>
            <div onClick={() => props.changeAvailabilityCustomSelection(true, false)} style={containerItem}>
                <span style={props.isProductWeekAvailability ? activeElement : null}>{i18n.t('screens:menuScreen.weekAvailability')}</span>
            </div>
            <div style={{ padding: '0 7px 3px', color: 'rgb(169, 169, 169)' }}>/</div>
            <div onClick={() => props.changeAvailabilityCustomSelection(false, true)} style={containerItem}> 
                 <span style={props.isProductDayAvailability ? activeElement : null}>{i18n.t('screens:menuScreen.dayAvailability')}</span>
            </div>
        </Col>
    );
}

export default AvailabilityCustomSelection;

const styles = {
    container: {
        display: 'flex',
        paddingLeft: '0px',
        alignItems: 'end'
    },
    activeElement: {
        color: '#0288d1'
    },
    containerItem: {
        padding: '10px 0 5px',
        fontSize: '14px',
        cursor: 'pointer'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/availability/AvailabilityCustomSelection.js